export const openLoginModal = data => {
    return {
        type: 'OPEN_LOGIN_MODAL',
    }
}

export const closeLoginModal = data => {
    return {
        type: 'CLOSE_LOGIN_MODAL',
    }
}

export default {
    closeLoginModal,
    openLoginModal,
}
